import React, { Component } from "react";
import { allowedUsers } from "../../../constants/insurance/constant";

class HeaderTags extends Component {

    constructor(props) {
        super(props);
        const username = localStorage.getItem("userName");
        const role = localStorage.getItem("roleName"); 
        this.state = {
            location: this.props.location,
            page: this.props.page,
            dashboards:[
                ...(allowedUsers.includes(username) ? [{ id: 3, name: 'Charts', page: 1 }] : []),
                { id: 1, name: 'All Appointments', page: 1 },
                { id: 2, name: 'Esales Queue', page: 1 },
            ].filter((dashboard) => !(role === "insureragent" && dashboard.name === 'Charts')),
        }
        let x = this.state.location.split('/')[3] ? this.state.location.split('/')[3] : null;

           this.checkTheDashboard(x);
    }

    assignDashboard(id, name, pageNo) {
        let obj = JSON.parse(localStorage.getItem("pageTracking"))
        if(!obj)
            obj ={}
        let rows = null;
        if(window.location.hash === localStorage.getItem("req")){
            rows = JSON.parse(localStorage.getItem("pageTracking")).totalRows
        }
        localStorage.setItem("pageTracking",JSON.stringify({
            ...obj,
            id:id,
            name:name,
            page:pageNo,
            totalRows:rows
        }))
        this.setState({
            id:id,
            name:name,
            page:pageNo
        })
    }

    checkTheDashboard(path,test=null) {
        switch (path) {
            case "esalesqueue": this.assignDashboard(2, "Esales Queue", test?test:this.props.page); break;
            case "charts": this.assignDashboard(3, "Charts", test?test:this.props.page); break;
            default: this.assignDashboard(1, "All Appointments", test?test:this.props.page); break;
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.setState({
                location: this.props.location 
            }, () => {
                let x = this.props.location.split('/')[3] ? this.props.location.split('/')[3] : null;
                // if(!(this.props.location.pathname.includes("history") || prevProps.location.pathname.includes("history")))
                    this.checkTheDashboard(x)
            });
        }
        if (this.props.page !== prevProps.page) {
            this.setState({
                page: this.props.page
            }, () => {
                let x = this.props.location.split('/')[3] ? this.props.location.split('/')[3] : null;
                this.checkTheDashboard(x)
            });
        }
    }

    RouteToReceivedDocuments(id) {
        switch (id) {
            case 1: this.props.history.push("/" + localStorage.getItem("roleName") + "/appointments/"); break;
            case 2: this.props.history.push("/" + localStorage.getItem("roleName") + "/appointments/esalesqueue"); break;
            case 3: this.props.history.push("/" + localStorage.getItem("roleName") + "/charts"); break;
            default: this.props.history.push("/" + localStorage.getItem("roleName") + "/charts"); break;
        }
    }

    render() {
        return (
            <div className="pb-10">
                <div className="table bg-gray-300 w-full text-sm">
                    {
                        this.state.dashboards.map((elem, index) =>{
                            let id = JSON.parse(localStorage.getItem("pageTracking")).id
                            return(
                            <div key={elem.id} className={(elem.id=== id ? (index === 0) ? 'table-cell text-center bg-white rounded-tr-xl font-semibold' : (index === this.state.dashboards.length - 1) ? 'table-cell text-center bg-white  rounded-tl-xl font-semibold' : 'table-cell text-center bg-white  rounded-t-xl font-semibold' : 'table-cell text-center')} onClick={() => this.RouteToReceivedDocuments(elem.id)}>
                                <div className={(elem.dashboardShown ? 'px-2 py-4 text-gray-900 cursor-pointer rounded rounded-t-xl' : 'px-2 py-4 text-gray-500 cursor-pointer')}>
                                    <div className={(elem.dashboardShown ? 'hover:text-gray-600' : 'hover:text-gray-800')}>{elem.name}</div>
                                </div>
                            </div>
                        )})
                    }
                </div>
            </div>
        );
    }

}

export default HeaderTags;